import React, { useState } from "react";
import { FeedCurve } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { cloneDeep } from "lodash";
import { AnimalInfo } from "../../../Services";
import constructDataMap from "./_FeedCurveViewer/constructDataMap";
import { glyphs, useMediaQuery } from "../../../Styles";
import NewButton from "../../BaseComponents/newButton";
import { ButtonTypes } from "../../../Definitions";
import { InfoBoxGeneral, InfoBoxMilestones, InfoBoxUsage } from "./SubComponents";
import FeedCurveGraph from "./rawFeedCurveGraph";

interface FeedCurveWithInfoBoxesProps {
  data: FeedCurve;
  invertedColors?: boolean;
  animals?: AnimalInfo[]; 
}

export default function FeedCurveWithInfoBoxes({ data: feedCurve, invertedColors = false, animals }: FeedCurveWithInfoBoxesProps) {
  const desktop = useMediaQuery(`(min-width: 1410px)`);
  const [showInfo, setShowInfo] = useState<boolean>(desktop ? true : false);
  const { dataMap, lastDay, firstDay, maxAmount, minAmount, milestonesFirstDay } = constructDataMap(cloneDeep(feedCurve));
  const amountOfDays = (lastDay+1) - firstDay; // +1 due to the fence post problem  .

  return (
    <div style={{width: "100%", height: "fit-content", boxSizing: "border-box", display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", justifyContent: "center", position: "relative"}}>
      <div style={{position: "relative", zIndex: showInfo === true ? "1" : "2"}}>
        {feedCurve &&
          <FeedCurveGraph
            data={feedCurve}
            invertedColors={invertedColors}
            milestones={{
              showMilestones: true,
              showMilestoneToolTip: true
            }}
            dataMapConstruction={{
              dataMap: dataMap,
              firstDay: firstDay,
              lastDay: lastDay,
              maxAmount: maxAmount,
              milestonesFirstDay: milestonesFirstDay,
              minAmount: minAmount
            }}
            
          />
        }
          <div style={{ position: "absolute", bottom: "30px", right: "0px" }}>
            <NewButton
              content=""
              buttonType={ButtonTypes.glyphButton}
              startEnhancer={glyphs.Info({size: "25px"})}
              onClick={() => setShowInfo(!showInfo)}
              overrides={{
                baseStyles: { opacity: showInfo ? "1" : "0.5" },
                hoverStyles: { opacity: showInfo ? "0.5" : "1" },
              }}
            />
          </div>
      </div>
      <div style={{zIndex: showInfo === true ? "2" : "1", transition: "0.5s ease"}}>
        <div style={{display: "flex", flexDirection: "column", gap: "10px", position: "absolute", top: "0px", left: "0px", opacity: showInfo ? "1" : "0", transition: "opacity 0.3s ease" }}>
          <InfoBoxUsage feedCurve={feedCurve} animals={animals ?? []} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", position: "absolute", top: "0px", right: "0px", opacity: showInfo ? "1" : "0", transition: "opacity 0.3s ease" }}>
          <InfoBoxGeneral feedCurve={feedCurve} amountOfDays={amountOfDays} />
          <InfoBoxMilestones milestones={feedCurve.milestones} />
        </div>
      </div>
    </div>
  );
}